/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Linestring (epsg:4326) specified in wkt or geojson. Coordinates in longitude, latitude order.
 * @export
 * @interface Linestring
 */
export interface Linestring {
  /**
   * Type should always be 'linestring' or 'LINESTRING'
   */
  type: string;
  /**
   * List of coordinates. (longitude, latitude order)
   */
  coordinates: Array<Array<number>>;
}

/**
 * Check if a given object implements the Linestring interface.
 */
export function instanceOfLinestring(value: object): value is Linestring {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("coordinates" in value) || value["coordinates"] === undefined) return false;
  return true;
}

export function LinestringFromJSON(json: any): Linestring {
  return LinestringFromJSONTyped(json, false);
}

export function LinestringFromJSONTyped(json: any, ignoreDiscriminator: boolean): Linestring {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    coordinates: json["coordinates"],
  };
}

export function LinestringToJSON(json: any): Linestring {
  return LinestringToJSONTyped(json, false);
}

export function LinestringToJSONTyped(
  value?: Linestring | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
